import React from 'react';
import './App.css';
import { AppRoutes } from './routers';
import { ThemeProvider, createTheme } from '@mui/material';
import { I18nProvider } from './context/I18n/I18n';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useAuthContext } from './context/AuthContext/AuthContext';
import Loading from './components/Loading';

const theme = createTheme({
  typography: {
    fontFamily: 'Be Vietnam Pro',
  },
});
const queryClient = new QueryClient();

function App() {
  const { loading } = useAuthContext();

  return (
    <div style={{ position: 'relative', zIndex: 10 }}>
      <ThemeProvider theme={theme}>
        <React.Suspense fallback={<Loading />}>
          {!loading ? (
            <QueryClientProvider client={queryClient}>
              <I18nProvider>
                <AppRoutes />
              </I18nProvider>
            </QueryClientProvider>
          ) : (
            <Loading />
          )}
        </React.Suspense>
      </ThemeProvider>
    </div>
  );
}

export default App;
